export default {
  install(Vue) {
    Vue.prototype.$loadReepay = () => {
      return new Promise((resolve, reject) => {
        if (window.Reepay) {
          resolve(window.Reepay);
        } else {
          const script = document.createElement("script");
          script.src = "https://checkout.reepay.com/checkout.js";
          script.async = true;
          script.onload = () => resolve(window.Reepay);
          script.onerror = reject;
          document.head.appendChild(script);
        }
      });
    };
  },
};
